
import { Vue, Component, Prop } from 'vue-property-decorator'
import { paymethodTypeMap } from '@/const/payment'

@Component({
  components: {
  }
})
export default class ForwardPC extends Vue {
  @Prop({ default: false, type: Boolean, required: true }) readonly show: boolean
  @Prop({ default: paymethodTypeMap.PREDIT }) type: number
  @Prop({ type: String, default: '', }) title: string
  @Prop({ type: String, default: '', }) desc: string

  get helpList() {
    const list = new Array(2).fill(0).map((item, index) => ({
      subtitle: `purchase_help_subtitle${index}`,
      desc: `purchase_help_desc${index}`
      // desc: 'this is a long long text, this is a long long text this is a long long text, this is a long long text, this is a long long text this is a long long text this is a long long text.'
    }))
    if (this.type === paymethodTypeMap.CREDIT) {
      list[0].desc = `purchase_help_desc0_credit`
    }
    return list
  }

  handleClose() {
    this.$emit('close')
  }
}
